import { createRouter, createWebHistory } from 'vue-router'
import Reader from '@/views/Reader'
import DirectDocumentLoader from '@/views/DirectDocumentLoader'
// import Library from '@/views/Library'
import PublicationLoader from '@/views/PublicationLoader'
import ShopBasket from '@/views/ShopBasket'
import ShopCheckout from '@/views/ShopCheckout'
import ShopSuccess from '@/views/ShopSuccess'
import Home from '@/views/Home'
import Results from '@/views/Results'
import AdminArea from '@/views/AdminArea'
import Bookshelf from '@/views/Bookshelf'
import BookshelfContent from '@/views/BookshelfContent'
import { routeBeforeEachHandler } from '@/utilities/routerHelper'

import Roles from '@/constants/roles'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { protected: true }
  },
  {
    path: '/search',
    name: 'results',
    component: Results,
    meta: { protected: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminArea,
    meta: { protected: true, role: Roles.ADMIN }
  },
  {
    path: '/shop',
    redirect: { name: 'results' }
  },
  {
    path: '/shop/basket',
    name: 'shop_basket',
    component: ShopBasket,
    meta: { protected: true, role: Roles.ADMIN }
  },
  {
    path: '/shop/checkout',
    name: 'shop_checkout',
    component: ShopCheckout,
    meta: { protected: true, role: Roles.ADMIN }
  },
  {
    path: '/shop/success',
    name: 'shop_success',
    component: ShopSuccess,
    meta: { protected: true, role: Roles.ADMIN }
  },
  {
    path: '/reader/:docKey',
    name: 'reader',
    component: Reader,
    meta: { protected: true }
  },
  {
    path: '/document/open',
    name: 'directdocumentloader',
    component: DirectDocumentLoader,
    meta: { protected: false }
  },
  {
    path: '/document/:docKey',
    redirect: to => ({ name: 'reader', params: { docKey: to.params.docKey } })
  },
  {
    path: '/bookshelf',
    name: 'bookshelf',
    component: Bookshelf,
    meta: { protected: true },
    children: [
      {
        path: ':id(\\d+)',
        name: 'bookshelfContent',
        component: BookshelfContent
      }
    ]
  },
  {
    path: '/:pubKey(pub-.*)',
    name: 'publicationloader',
    component: PublicationLoader,
    meta: { protected: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(routeBeforeEachHandler)

export default router
